import React from 'react';

import './Sites.scss';
import languageMap from 'Language/Language';
const Sites = () => {
  return <div className="Sites_contactText title-text">{languageMap.genAiSites}</div>;
};

export default Sites;
